module.exports = __webpack_public_path__ + "assets/img/logo-login.a173d864.png";